// Screen `security` — design/screens/Security.dc.html — owner: S10. Settings › Security & data.
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { SecurityPage } from '../../../features/access/SecurityPage';

export const Route = createFileRoute('/_settings/settings/security')({
  // A test sign-in used to come back here: its result belongs to Settings › Sign-in now.
  validateSearch: z.object({
    sso_test: z.enum(['ok', 'failed']).optional(),
    sso_email: z.string().max(254).optional(),
    sso_error: z.string().max(300).optional(),
  }),
  beforeLoad: ({ search }) => {
    if (search.sso_test) throw redirect({ to: '/settings/sign-in', search, replace: true });
  },
  component: SecurityPage,
});
